<template>
  <div class="activity">
    <div class="container">
      <ActivityRegister :data="this.listData" @statusClick="handleStatusClick">
      </ActivityRegister>
    </div>
    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import ActivityHeader from './activitysheader.vue'
import ActivityRegister from '@/views/activity/activity-register'
import * as api from '@/service/index'
import Prompt from '@/components/prompt'

export default {
  components: {
    // ActivityHeader,
    ActivityRegister,
    Prompt
  },
  data() {
    return {
      classMode: ['undone', 'receive', 'received'],

      activeTitle: ['每日打卡', '累计打卡'],
      // 默认状态第一个元素
      selected: 0,

      listData: [],
      // 状态锁
      inRequest: false,

      // 红点展示状态
      showPrompt: false,
      // 累计
      accrue: false,
      // 每日
      daily: false
    }
  },
  created() {
    this.fetchActivityList()
   
    // console.log( this.formatDay('2024-09-04T17:03:00+08:00'))
  },
  computed: {
    ...mapState(['token','amount']),
    // selectedData() {
    //   if (this.selected !== null) {
    //     return this.listData[this.selected]
    //   }
    //   return null
    // }
  },
  methods: {
    ...mapActions(['reqUserInfo','reqRedDotState']),
    ...mapMutations(['SET_SHOWLINGQU']),
    hasAgeValue(arr, targetValue) {
      return arr.some((obj) => obj.status == targetValue)
    },
    async fetchActivityList() {
      if(!this.token) return;
      try {
        const res = await api.getActivityList({token:this.token,taskType:1})
        if (res.status === 200) {
          const { cumulative, dailyTasks } = res.data
          this.listData.push(dailyTasks, cumulative)
        }else{
          alert(res.data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    toggle(index) {
      if (this.selected === index) {
        return
      }
      this.selected = index
    },


    formatDay(time) {
     
      // const isoDateString = time.replace(" ", "T");
      let dateObj = new Date(time);
      let month = dateObj.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = dateObj.getDate();
      day = day < 10 ? "0" + day : day;
      return `${month}月${day}日`;
    },
    
    async handleStatusClick(status, value ,type) {
      if (this.classMode[status] == 'receive' && !this.inRequest) {
        this.inRequest = true
        let data = {
            taskId:value.id
          }
        if(!this.token) return;
        try {
          let response = await api.getActivityReward(this.token, data)
          // console.log('response',response)
          const dbtitle = type ? '每日任务领取奖励' : "累计任务领取奖励";
          if (response.status == 200 && response.data === true) {
            this.fetchActivityList()
            this.reqRedDotState()
            // isSend 区分是礼物还是货币
            const  now = await api.reqcurrentTime()
            if(value.isSend){
              if(!this.token) return;
             const res = await api.reqGiftList({token: this.token,force : true})

              if(res.status === 200){
                res.data?.find(item => {
                  if(typeof tapdb == 'undefined') return;
                  if(item.giftId == 'xc006'){
                    if(now.status == 200){
                    const countdown = this.formatDay(now.data)
                    // 领取任务奖励
                    // console.log(value.id +"+"+countdown)
                      tapdb.trackEvent(dbtitle, {
                        // 领取任务奖励 道具
                        '#mission_unique_id': value.id +"+"+countdown,
                        // 获得道具数量
                        '#item_gain': + value.coins,
                        // 道具变化余量
                        '#prop_after': item.count,
                        // 道具id
                        '#prop_id': item.giftId,
                        // 道具原因
                        '#prop_type' : value.title
                      });
                    }
                  }
                })
              }
            }else{
              this.reqUserInfo(true)
              if(now.status == 200){
                if(typeof tapdb == 'undefined') return;
                const countdown = this.formatDay(now.data)
                // 领取任务奖励 货币
                // 埋点描述
                  tapdb.trackEvent(dbtitle, {
                    // 埋点行为，领取任务
                  '#mission_unique_id': value.id +"+"+countdown,
                  // 本次货币变化
                  '#value_change': +value.coins,
                  // 变化余量
                  '#value_after': +this.amount.quizRemainNum,
                  // 任务id
                  '#coin_id': value.id,
                  // 任务描述
                  '#via_type':value.desc,
                });
              }
            }

            this.inRequest = false
            this.$refs.prompt.setMsg('领取成功～')     
           
          }
        }catch (err) {
          console.log(err)
        }
      }
    }
  }
}
</script>

<scirpt/>

<style lang="scss" scoped>
@import '~@/assets/scss/activity/index';
</style>